import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminModal from '../components/AdminModal';

/**
 * Page dédiée à la gestion des parties prenantes (même contenu que la card Administration PRIsME BZ).
 * Ouverture de AdminModal en plein écran ; fermeture = retour à l'accueil.
 */
export default function GestionPartiesPrenantes() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
    navigate('/');
  };

  return <AdminModal isOpen={open} onClose={handleClose} />;
}
